// import Navbar   from "../../components/c_navbar";
import Menu     from "../../components/Menu/menu.jsx";
// import Busca    from   "../../components/Busca/c_busca.jsx";
// import SideBar from "../../components/Menu/SideBar/c_sidebar.jsx";

import './trocarcidade.css';

function ClienteTrocarCidade (){
    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    {/* <Navbar /> */}
                    <Menu page="trocarcidade"/>
                    {/* <SideBar/> */}
                </div>
                <div className="col py-3 me-3">
                    {/* <Busca/> */}
                    <h1>Trocar Cidade Temporariamente</h1>
                    <h4>País</h4>
                    <h4>Estado</h4>
                    <h4>Cidade</h4>
                </div>
            </div>

        </div>
    </>
}

export default ClienteTrocarCidade;